var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "wysiwyg-content",
    domProps: { innerHTML: _vm._s(_vm.sanitizedContent) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }